import * as yup from 'yup';

export const PRJ_KEY = {
  APP_TYPE:'Application type',
  SRCH_BY: 'SearchKey',
  PRJ_ID: 'project_NB',
  OPCO: 'opco',
  STATUS: 'status',
};

export const initialValues = {
  [PRJ_KEY.APP_TYPE]:'Interconnect',
  [PRJ_KEY.SRCH_BY]: 'Application Number',
  [PRJ_KEY.PRJ_ID]: '',
  [PRJ_KEY.OPCO]: '',
  [PRJ_KEY.STATUS]: '',
};

export const ValidationSchema = yup.object().shape({
  [PRJ_KEY.PRJ_ID]: yup.string().when([PRJ_KEY.SRCH_BY], {
    is: (value) => !nonFieldOption.includes(value),
    then: () => yup.string().required('Required'),
  }),
  [PRJ_KEY.OPCO]:yup.string().when([PRJ_KEY.SRCH_BY], {
    is: (value) => value === 'Opco & Status',
    then: () => yup.string().required('Required'),
  }),
  [PRJ_KEY.STATUS]:yup.string().when([PRJ_KEY.SRCH_BY], {
    is: (value) => value === 'Opco & Status',
    then: () => yup.string().required('Required'),
  }),
  [PRJ_KEY.APP_TYPE]:yup.string().when([PRJ_KEY.SRCH_BY], {
    is: (value) => value === 'Application Type',
    then: () => yup.string().required('Required'),
  })
});

export const nonFieldOption = ['Opco & Status','Application Type']

